import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.a`
  color: ${(props) => (props.selected ? '#ffeb3b' : '#ffffff')};
  cursor: pointer;
  display: inline-block;
  flex: 0 1 auto;
  margin: 0 2%;
  opacity: ${(props) => (props.selected ? 1 : 1)};
  padding: 1em 0;
  text-align: center;
  transition: opacity 0.2s linear;
  text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.65);
  :hover {
    opacity: 1;
  }
`;

export class Tab extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    value: PropTypes.string.isRequired,
  };

  static defaultProps = {
    onChange: null,
    onClick: null,
    selected: false,
  };

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    const { onChange, onClick, value } = this.props;

    if (onChange) {
      onChange(e, value);
    }

    if (onClick) {
      onClick(e);
    }
  }

  render() {
    const { selected } = this.props;
    return (
      <Wrapper selected={selected} onClick={this.onClick}>
        {this.props.children}
      </Wrapper>
    );
  }
}
